/*
Copyright (c) 2021
*/

import constants from '../../constants';

const {
  REQUEST_STARTINTERVIEW,
  STARTINTERVIEW_RECEIVED,
  SEND_PARTICIPANTS_LIST_ONSTART,
  SEND_PARTICIPANTS_LIST_RECIEVED_ONSTART,
  REQUEST_UPDATELAYOUT,
  UPDATELAYOUT_RECIEVED
} = constants.StartInterviewConstant;

export default {
  REQUEST_STARTINTERVIEW,
  STARTINTERVIEW_RECEIVED,
  SEND_PARTICIPANTS_LIST_ONSTART,
  SEND_PARTICIPANTS_LIST_RECIEVED_ONSTART,
  REQUEST_UPDATELAYOUT,
  UPDATELAYOUT_RECIEVED,

  requestStartInterview: payload => ({
    type: REQUEST_STARTINTERVIEW,
    payload
  }),
  StartInterviewReceived: () => ({
    type: STARTINTERVIEW_RECEIVED
  }),

  SendParticpantsList: payload => ({
    type: SEND_PARTICIPANTS_LIST_ONSTART,
    payload
  }),
  SendParticpantsListReceived: () => ({
    type: SEND_PARTICIPANTS_LIST_RECIEVED_ONSTART
  })
};

export const requestUpdateVideoLayout = data => ({
  type: REQUEST_UPDATELAYOUT,
  payload: data
});

export const UpdateVideoLayoutRecieved = data => ({
  type: UPDATELAYOUT_RECIEVED,
  payload: data
});
